var map = {
	"./Card": 982,
	"./Card.js": 982,
	"./Card.module.css": 447,
	"./images/aws.png": 61,
	"./images/bootstrap.png": 55,
	"./images/css.png": 775,
	"./images/django.png": 912,
	"./images/flask.png": 684,
	"./images/heroku.png": 276,
	"./images/html.png": 90,
	"./images/javascript.png": 443,
	"./images/jquery.png": 892,
	"./images/mongodb.png": 494,
	"./images/postgresql.png": 191,
	"./images/project1.png": 426,
	"./images/project2.png": 836,
	"./images/project3.png": 115,
	"./images/python.png": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 927;